import {z} from 'zod';

// Converts "", null, undefined to null
// Converts numbers and numeric strings to number
const numOrEmpty = z.preprocess(val => {
  if (val === '' || val === null || val === undefined) return null;
  const n = Number(val);
  return Number.isNaN(n) ? val : n;
}, z.number().min(0).nullable());

// Strict valid practitioner
const practitionerActivitySchema = z.object({
  hoursWorked: z.number().min(0),
  missedAppointments: z.number().min(0),
  newPatients: z.number().min(0),
  treatmentPlansProposed: z.number().min(0),
  crownsPlaced: z.number().min(0),
  activeOrthoPatients: z.number().min(0),
  scheduledAppointments: z.number().min(0),
  patientsTreated: z.number().min(0),
  emergencies: z.number().min(0),
  treatmentPlansAccepted: z.number().min(0),
  implantsPlaced: z.number().min(0),
  revenue: z.number().min(0)
});

// Accepts empty or partial practitioner
const practitionerOrEmpty = z.object({
  hoursWorked: numOrEmpty,
  missedAppointments: numOrEmpty,
  newPatients: numOrEmpty,
  treatmentPlansProposed: numOrEmpty,
  crownsPlaced: numOrEmpty,
  activeOrthoPatients: numOrEmpty,
  scheduledAppointments: numOrEmpty,
  patientsTreated: numOrEmpty,
  emergencies: numOrEmpty,
  treatmentPlansAccepted: numOrEmpty,
  implantsPlaced: numOrEmpty,
  revenue: numOrEmpty
});

// Record of practitioners
export const formSchema = z.record(z.string(), practitionerOrEmpty).superRefine((record, ctx) => {
  let atLeastOneValid = false;

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(record)) {
    const parsed = practitionerActivitySchema.safeParse(value);

    if (parsed.success) {
      atLeastOneValid = true;
    }
  }

  if (!atLeastOneValid) {
    ctx.addIssue({
      path: [],
      code: z.ZodIssueCode.custom,
      message: 'At least one practitioner must have valid data'
    });
  }
});
